var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticClass:"mb-4",attrs:{"flat":"","tile":""}},[_c('v-toolbar-items',[_c('v-btn',{attrs:{"to":{name: 'admin.user_contacts.index'},"text":"","exact":""}},[_vm._v("\n      Contacts\n    ")]),_vm._v(" "),_c('v-btn',{attrs:{"to":{name: 'admin.user_contacts.upload'},"text":"","exact":""}},[_vm._v("\n      Upload\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }